import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ENCRYPTABLE_METHODS } from '../../const/encryptable-methods.conts';
import {
  ENCRYPT_PAYLOAD,
  PayloadEncryptionService
} from '../../services/payload-encryption/payload-encryption.service';

export const payloadEncryptionInterceptor: HttpInterceptorFn = (req, next) => {
  const shouldEncrypt = req.context.get(ENCRYPT_PAYLOAD);

  if (!shouldEncrypt || !req.body || !ENCRYPTABLE_METHODS.has(req.method)) {
    return next(req);
  }

  const rsaPbKey = environment.rsaPbKey;
  if (!rsaPbKey) throw new Error('RSA public key not configured');

  const encryptionService = inject(PayloadEncryptionService);

  return encryptionService.getEncryptPayload(req.body, rsaPbKey).pipe(
    switchMap(encryptedPayload =>
      next(
        req.clone({
          body: { data: encryptedPayload }
        })
      )
    )
  );
};
